import { MEDIO_DE_PAGO } from "../constants";

// Compara los campos dados en un array dentro de un producto y devuelve verdadero si alguno de los campos contiene el valor de search
export function compareText(fields, prod, search) {
    if (!prod) return false;
    const busqueda = search.toLowerCase();
    let valido = false;
    fields.forEach((field) => {
        if (valido) return;
        let campo
        if (field === 'codigo') {
            campo = `${prod.UserId}.${prod.codigoProducto}`;
        } else {
            campo = prod[field] ? prod[field].toLowerCase() : '';
        }
        valido = campo.includes(busqueda);
    });
    return valido;
}

export function getTimestampWithOffsetFromDate(date) {
    if (!date) return null;
    const lafecha = new Date(date);
    return lafecha.getTime() + (lafecha.getTimezoneOffset() * 60 * 1000);
}


export function esPagoEnEfectivo(medioDePago) {
    let resultado = false;
    switch (medioDePago) {
        case MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO:
        case MEDIO_DE_PAGO.EFECTIVO:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TC:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TD:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TRANSFERENCIA:
            resultado = true;
            break;
    }
    return resultado;
}

export function esPagoEnCredito(medioDePago, saldoCredito = 0) {
    let resultado = false;
    if (!isNaN(parseFloat(saldoCredito))) {
        if (parseFloat(saldoCredito) > 0) return true;
    }
    switch (medioDePago) {
        case MEDIO_DE_PAGO.CREDITO_Y_EFECTIVO:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TRANSFERENCIA:
            resultado = true;
            break;
    }
    return resultado;
}

export function pagoConOtrosMedios(medioDePago) {
    let resultado = false;
    switch (medioDePago) {
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TRANSFERENCIA:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TC:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TD:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TRANSFERENCIA:
        case MEDIO_DE_PAGO.TC:
        case MEDIO_DE_PAGO.TD:
        case MEDIO_DE_PAGO.TRANSFERENCIA:
            resultado = true;
            break;
    }
    return resultado;
}

export function incluyeRecargo(medioDePago) {
    let resultado = false;
    switch (medioDePago) {
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC:
        case MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TC:
        case MEDIO_DE_PAGO.EFECTIVO_Y_TD:
        case MEDIO_DE_PAGO.TC:
        case MEDIO_DE_PAGO.TD:
            resultado = true;
            break;
    }
    return resultado;
}